import {
  LayoutDashboard,
  Search,
  ListChecks,
  Compass,
  Crown,
  Shield,
  ShieldCheck,
  CalendarHeart,
  TrendingUp,
  LayoutGrid,
  Sparkles,
  Crosshair,
  Swords,
  Flame,
  BookOpen,
  SearchX,
  FileSearch,
  Stethoscope,
  Radar as RadarIcon,
  Settings as SettingsIcon,
  type LucideIcon,
} from 'lucide-react';
import type { UserRole, UserStatus } from '@keywordgod/shared';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  requireRole?: UserRole;
}

export const NAV: NavItem[] = [
  { label: '대시보드', to: '/', icon: LayoutDashboard },
  { label: '키워드분석', to: '/analyze', icon: Search },
  { label: '내일 핫', to: '/trending', icon: Flame },
  { label: '블로그코치', to: '/blog-coach', icon: Sparkles },
  { label: '1page 분석', to: '/serp-analysis', icon: Crosshair },
  { label: '경쟁 격차', to: '/blog-compare', icon: Swords },
  { label: '대량분석', to: '/bulk', icon: ListChecks },
  { label: '키워드발굴', to: '/discover', icon: Compass },
  { label: '카테고리', to: '/categories', icon: LayoutGrid },
  { label: '순위추적', to: '/rank', icon: TrendingUp },
  { label: '시즌 키워드', to: '/season', icon: CalendarHeart },
  { label: '황금키워드', to: '/golden', icon: Crown },
  { label: '사용법', to: '/help', icon: BookOpen },
  { label: '설정', to: '/settings', icon: SettingsIcon },
];

/**
 * 데스크톱 헤더 직접 노출 메뉴 (Phase 45 — 시인성 개선).
 * 13개 빽빽 → 5개만 직접 노출 + 나머지는 "더보기" 드롭다운.
 */
export const NAV_MAIN: NavItem[] = [
  { label: '키워드분석', to: '/analyze', icon: Search },
  { label: '키워드레이더', to: '/radar', icon: RadarIcon },
  { label: '내일 핫', to: '/trending', icon: Flame },
  { label: '블로그코치', to: '/blog-coach', icon: Sparkles },
  { label: '황금키워드', to: '/golden', icon: Crown },
];

/** "더보기" 드롭다운에 들어갈 항목 — 분석 도구 + 발견 + 추적 + 설정 */
export const NAV_MORE: Array<NavItem & { group: string }> = [
  { label: '블로그 진단', to: '/blog-analysis', icon: Stethoscope, group: 'AI 도구' },
  { label: '1page 분석', to: '/serp-analysis', icon: Crosshair, group: 'AI 도구' },
  { label: '경쟁 격차', to: '/blog-compare', icon: Swords, group: 'AI 도구' },
  { label: '포스팅 품질', to: '/post-quality', icon: FileSearch, group: 'AI 도구' },
  { label: '키워드발굴', to: '/discover', icon: Compass, group: '발견' },
  { label: '카테고리', to: '/categories', icon: LayoutGrid, group: '발견' },
  { label: '대량분석', to: '/bulk', icon: ListChecks, group: '발견' },
  { label: '시즌 키워드', to: '/season', icon: CalendarHeart, group: '발견' },
  { label: '순위추적', to: '/rank', icon: TrendingUp, group: '추적' },
  { label: '누락검출', to: '/missing', icon: SearchX, group: '추적' },
  { label: '사용법', to: '/help', icon: BookOpen, group: '기타' },
  { label: '설정', to: '/settings', icon: SettingsIcon, group: '기타' },
];

/** 운영진 전용 (admin + moderator) */
export const STAFF_NAV: NavItem[] = [
  { label: '운영자 콘솔', to: '/mod', icon: ShieldCheck, requireRole: 'moderator' },
  { label: '관리자 콘솔', to: '/admin', icon: Shield, requireRole: 'admin' },
];

export const ROLE_LABEL: Record<UserRole, string> = {
  admin: '관리자',
  moderator: '운영진',
  member: '회원',
};

export const ROLE_COLOR: Record<UserRole, string> = {
  admin: 'bg-gold/15 text-gold',
  moderator: 'bg-blue-500/15 text-blue-300',
  member: 'bg-gray-700 text-gray-300',
};

export const STATUS_LABEL: Record<UserStatus, string> = {
  pending: '승인 대기',
  active: '활성',
  suspended: '정지',
};

export const STATUS_COLOR: Record<UserStatus, string> = {
  pending: 'bg-amber-500/15 text-amber-300',
  active: 'bg-emerald-500/15 text-emerald-300',
  suspended: 'bg-red-500/15 text-red-300',
};
